module.exports = {
  LOCALES: ['uk', 'ru', 'en', 'pl'],
  DEFAULT_FRONT_PAGE_SLUG: 'ehealth',
  DEFAULT_LOCALE: 'uk',
  POSTS_COUNT: 3,
  PHONES: {
    SUPPORT: '+38 (093) 059 - 43 - 44',
    HELP: '+38 (093) 059 - 43 - 44',
  },
  EMAILS: {
    HELP: 'info@myheal.com.ua',
  },
  FORMAT: {
    DATE: 'dd.MM.yyyy',
    TIME: 'HH:mm',
  },
  MEDIAQUERY: {
    MOBILE: 847,
    LAPTOP: 992,
    DESKTOP: 1440,
  },
  CONTENT: {
    VIDEO: {
      PATIENT: 'https://www.youtube.com/embed/yaOtdtCD1Mg',
      DOCTOR: 'https://www.youtube.com/embed/yaOtdtCD1Mg',
      COMPANY: 'https://www.youtube.com/embed/yaOtdtCD1Mg',
      EHEALTH: 'https://www.youtube.com/embed/yaOtdtCD1Mg',
    },
  },
  SOCIAL: {
    FACEBOOK: 'https://www.facebook.com/myhealua',
    INSTAGRAM: 'https://www.instagram.com/myheal.com.ua',
    LINKEDIN: 'https://www.linkedin.com/showcase/medical-platform-myheal',
    YOUTUBE: 'https://www.youtube.com/channel/UClhhs2L1gJv6m5Fj_Kdhpag',
    VIBER: 'viber://pa/qr?chatURI=0930594344',
  },
};
